import { Stack } from "@mui/system";
import * as React from "react";
import { XPageProps } from "../utils/interfaces/core/XPage";
import Browser from "./Browser";
import XGUI from "./gui/XGUI";
import XPage from "./XPage";

export const XEditor: React.FC<XPageProps> = (props) => {
  return (
    <Stack
      id="XEditor"
      direction="row"
      width="100%"
      sx={{ height: "calc(100vh - 155px)", boxSizing: "border-box" }}
      px={2}
      spacing={2}
    >
      <Stack flex={1} alignItems="center">
        <Browser>
          <XPage {...props} />
        </Browser>
      </Stack>
      <XGUI />
    </Stack>
  );
};

export default XEditor;
